import { Component } from 'preact';

import { CasinoService as LegacyCasino } from './casino/legacy-api';
import { CasinoService as NextCasinoApi } from './casino/new-api';

export const LEGACY_CASINO = new LegacyCasino();
export const NEW_CASINO = new NextCasinoApi();

export type GameEntry = {
    /** aggregator */
    provider: string;
    /** brand */
    category: string;
    /** game */
    id: string;
    logo: string;
    name: string;
    tags?: string[];
    sort: number;
};

export type GamesBrand = {
    /** brand */
    id: string;
    /** aggregator */
    provider: string;
    name: string;
    logo: string;
    sub: GameEntry[];
};

export default class CasinoService extends Component {
    static INSTANCE: CasinoApi = LEGACY_CASINO;

    render() {
        return null;
    }

    componentWillMount() {
        CasinoService.INSTANCE.setup();
    }
    static applyCategoryFilter(category: false | string, provider: false | string = false) {
        return CasinoService.INSTANCE.applyCategoryFilter(category, provider);
    }
    static getSelectedCategoryId() {
        return CasinoService.INSTANCE.getSelectedCategoryId();
    }
    static getSelectedCategoryName() {
        return CasinoService.INSTANCE.getSelectedCategoryName();
    }
    static clearCategoryFilter() {
        return CasinoService.INSTANCE.clearCategoryFilter();
    }
    static asNewCasino(): NextCasinoApi {
        return this.INSTANCE as NextCasinoApi
    }

    static providersList() {
        return CasinoService.INSTANCE.providersList();
    }

    static getPlayUrl(provider: string, brand: string, game: string) {
        return CasinoService.INSTANCE.getPlayUrl(provider, brand, game);
    }

    static listenChanges = (cb: { (): void; }) => {
        return CasinoService.INSTANCE.listenChanges(cb);
    }
    static unlistenChanges = (cb: { (): void; }) => {
        return CasinoService.INSTANCE.unlistenChanges(cb);
    }
    static notifyChanges = () => {
        return CasinoService.INSTANCE.notifyChanges();
    }
    static flattenSlotList = () => {
        return CasinoService.INSTANCE.flattenSlotList();
    }
}

export interface CasinoApi {
    flattenSlotList(): GameEntry[];

    notifyChanges(): void;
    unlistenChanges(cb: { (): void; }): void;
    listenChanges(cb: { (): void; }): void;

    providersList(): { [key: string]: GamesBrand };
    getPlayUrl(provider: string, brand: string, game: string): string;

    clearCategoryFilter(): void;
    getSelectedCategoryName(): string;
    getSelectedCategoryId(): string | false
    applyCategoryFilter(category: string | false, provider?: string | false): void;

    setup(): Promise<void>;
}

/**
 * Salva i giochi preferiti e giochi aperti
 */
export class CasinoFavourites {
    static FAVOURITES: GameEntry[] = safe(() => JSON.parse(window.safeLocalStorage.getItem('casino-favourites')) || [], [])
    static PLAYED: GameEntry[] = safe(() => JSON.parse(window.safeLocalStorage.getItem('casino-played')) || [], [])

    static getPlayed() {
        return this.PLAYED.slice(0).reverse();
    }
    static getFavourites() {
        return this.FAVOURITES.slice(0).reverse();
    }

    static isFavourite(game: GameEntry) {
        return this.FAVOURITES.filter(g => (g.category == game.category && g.id == game.id)).length > 0
    }
    static addFavourite(game: GameEntry) {
        let favs = this.FAVOURITES;
        favs = favs.filter(g => !(g.category == game.category && g.id == game.id)).concat(game);
        this.FAVOURITES = favs;
        this.persistFavourites();
    }
    static removeFavourite(game: GameEntry) {
        let favs = this.FAVOURITES;
        favs = favs.filter(g => !(g.category == game.category && g.id == game.id));
        this.FAVOURITES = favs;
        this.persistFavourites();
    }
    static persistFavourites() {
        safe(() => window.safeLocalStorage.setItem('casino-favourites', JSON.stringify(this.FAVOURITES)), null);
        CasinoService.notifyChanges();
    }

    static addPlayed(game: GameEntry) {
        let favs = this.PLAYED;
        favs = favs.filter(g => !(g.category == game.category && g.id == game.id)).concat(game);
        this.PLAYED = favs;
        this.persistPlayed();
    }
    static removePlayed(game: GameEntry) {
        let favs = this.PLAYED;
        favs = favs.filter(g => !(g.category == game.category && g.id == game.id));
        this.PLAYED = favs;
        this.persistPlayed();
    }
    static persistPlayed() {
        safe(() => window.safeLocalStorage.setItem('casino-played', JSON.stringify(this.PLAYED)), null);
        CasinoService.notifyChanges();
    }
}

function safe<T>(fn: (() => T), err: null | T): null | T {
    try {
        return fn();
    } catch (e) {
        return err;
    }
}
